<template>
  <div class="flex flex-col mt-3 text-center" v-if="masterclass">
    <h2 class="flex flex-col mt-20 uppercase text-2xl text-beige-academy-300 font-semibold">
        {{ $t('masterclass.title') }}
    </h2>
    <div class="flex items-end justify-end w-3/4 mx-auto">
      <router-link to="/masterclasses" class="text-beige-academy-300
      hover:underline text-right pt-5 transform hover:-translate-y-1">
          {{ $t('masterclass.seeMore') }}
      </router-link>
    </div>
    <div class="rounded-md text-grey-academy-600 w-3/4 mx-auto">
      <masterclass-card :masterclass="masterclass" />
    </div>
    <div v-if="authenticated" class="pb-20 text-xl flex flex-col">
      <!-- <span>
        Il link per accedere alla masterclass sarà disponibile a partire da
        15 minuti prima dell'orario di inizio. <br>
        Potrai accedere direttamente da qui oppure dalla mail che riceverai quando la masterclass
        verrà avviata.
      </span>
      <button @click="joinMasterclassMeeting" v-if="masterclass && masterclass.is_started"
        class="mt-20 bg-orange-academy-300 text-white w-64 rounded mx-auto text-xl p-2 uppercase">
          Partecipa
      </button> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import MasterclassCard from './MasterclassCard.vue';

export default {
  components: { MasterclassCard },

  data() {
    return {
      masterclass: null,
    };
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),
  },

  created() {
    this.getNextMasterclass();
  },

  methods: {
    getNextMasterclass() {
      axios.get('/api/home-management/next-masterclass').then(({ data }) => {
        this.masterclass = data;
      }).catch((error) => {
        console.log(error);
      });
    },
  },
};
</script>
